import { formatDayLabel } from '@/shared/lib';

export interface ChatDayDividerProps {
  dayKey: string | null;
}

export function ChatDayDivider({ dayKey }: ChatDayDividerProps) {
  return (
    <div className="flex w-full justify-center py-2">
      <div className="rounded-full border bg-background px-3 py-1 text-[10px] font-medium text-muted-foreground">
        {formatDayLabel(dayKey)}
      </div>
    </div>
  );
}
